//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Breadcrumbs, Title, TitleBar } from '@/components/_common';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { selectDataTableAppliedSearchName } from '@/redux/selectors/dataTableSelectors';
import { clearFilters } from '@/redux/slices/dataTableSlice';
import { Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { selectCanWriteOrders } from '../../../redux/selectors/authSelectors';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const OrdersTitleBar = () => {
  const dispatch = useAppDispatch();
  const appliedSearchName = useAppSelector(selectDataTableAppliedSearchName);
  const canWriteOrders = useAppSelector(selectCanWriteOrders);

  const onBreadcrumbClick = () => {
    dispatch(clearFilters());
  };

  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center">
        {!appliedSearchName ? (
          <Title>Orders</Title>
        ) : (
          <Breadcrumbs aria-label="breadcrumb">
            <Link to="/orders" onClick={onBreadcrumbClick}>
              Orders
            </Link>
            <span>&ldquo;{appliedSearchName}&ldquo;</span>
          </Breadcrumbs>
        )}

        {canWriteOrders && (
          <Button variant="contained" color="primary" component={Link} to="orders-v2/new" startIcon={<PolarisIcon icon="add" height={16} />}>
            New Order
          </Button>
        )}
      </Grid>
    </TitleBar>
  );
};

export default OrdersTitleBar;
